import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import * as React from 'react';

interface Props {
    handleClose: (evt: React.MouseEvent) => void;
    handleRemove: (evt: React.MouseEvent) => void;
    isOpen: boolean;
    setIsOpen: React.Dispatch<boolean>;
    modalTitle: string;
    modalContent: React.ReactNode;
    primaryButtonText?: string;
    secondaryButtonText?: string;
    containerEl?: Element | null;
    anchorEl?: Element | null;
}

export const DeleteConfirmationModal = ({
    modalTitle,
    modalContent,
    handleClose,
    handleRemove,
    isOpen,
    setIsOpen,
    primaryButtonText = 'Delete',
    secondaryButtonText = 'Cancel',
    containerEl,
    anchorEl,
}: Props) => {
    return (
        <Popover
            open={isOpen}
            marginThreshold={50}
            container={containerEl}
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            onClose={(evt: any) => {
                evt.stopPropagation();
                evt.nativeEvent?.stopImmediatePropagation();

                setIsOpen(false);
            }}
        >
            <Box
                sx={{
                    maxWidth: '250px',
                    border: '1px solid',
                    borderColor: 'primary.main',
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                    padding: '20px 15px',
                }}
            >
                <Typography sx={{ fontWeight: 'bold', fontSize: 18 }}>{modalTitle}</Typography>
                <Typography sx={{ fontSize: 13, margin: '10px 0 20px' }}>{modalContent}</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Button sx={{ fontSize: '8px' }} color="primary" variant="outlined" onClick={handleClose}>
                        {secondaryButtonText}
                    </Button>
                    <Button sx={{ fontSize: '8px' }} color="primary" variant="outlined" onClick={handleRemove}>
                        {primaryButtonText}
                    </Button>
                </Box>
            </Box>
        </Popover>
    );
};
